import { Star } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * Small inline badge showing points earned on a treatment price.
 * Points = 1 per dollar spent (rounded down).
 */
const LoyaltyPointsBadge = ({ price, className = "" }) => {
  let numPrice = 0;
  if (typeof price === 'number') {
    numPrice = price;
  } else if (typeof price === 'string') {
    const cleaned = price.replace(/[^0-9.]/g, '');
    numPrice = parseFloat(cleaned) || 0;
  }

  if (numPrice <= 0) return null;

  const points = Math.floor(numPrice);

  return (
    <Link
      to="/crown-reserve"
      className={`inline-flex items-center gap-1 text-amber-600 hover:text-amber-500 transition-colors ${className}`}
      data-testid="loyalty-points-badge"
      title="Crown Reserve Loyalty Program"
    >
      <Star className="w-3 h-3 fill-amber-500 text-amber-500" />
      <span className="text-[11px] font-semibold">Earn {points} pts</span>
    </Link>
  );
};

/**
 * Compact loyalty banner for treatment pages.
 */
const LoyaltyBanner = ({ className = "" }) => {
  return (
    <Link
      to="/crown-reserve"
      className={`block group ${className}`}
      data-testid="loyalty-banner"
    >
      <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border border-amber-200 rounded-xl px-5 py-3.5 flex items-center justify-between hover:border-amber-400 hover:shadow-sm transition-all">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
            <Star className="w-5 h-5 fill-amber-500 text-amber-500" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900">
              Earn points on every treatment
            </p>
            <p className="text-xs text-gray-500">
              Redeem for discounts &mdash; Crown Reserve Loyalty
            </p>
          </div>
        </div>
        <span className="text-amber-600 text-xs font-semibold group-hover:translate-x-1 transition-transform hidden sm:block">
          Learn more &rarr;
        </span>
      </div>
    </Link>
  );
};

/**
 * Cart-style points summary for the booking cart footer.
 */
const LoyaltyCartSummary = ({ cartItems }) => {
  let totalPoints = 0;
  for (const item of cartItems) {
    let p = 0;
    if (typeof item.price === 'number') p = item.price;
    else if (typeof item.price === 'string') p = parseFloat(item.price.replace(/[^0-9.]/g, '')) || 0;
    totalPoints += Math.floor(p);
  }

  if (totalPoints <= 0) return null;

  return (
    <div className="flex items-center justify-center gap-1.5 text-amber-600 mt-1.5" data-testid="loyalty-cart-summary">
      <Star className="w-3.5 h-3.5 fill-amber-500 text-amber-500" />
      <span className="text-xs font-semibold">You'll earn {totalPoints} Crown Reserve points</span>
    </div>
  );
};

export { LoyaltyPointsBadge, LoyaltyBanner, LoyaltyCartSummary };
export default LoyaltyPointsBadge;
